



















import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { Job } from "../common/interfaces";
import DetailHeader from "../components/DetailHeader.vue";
import PartsSearch from "../components/requiredParts/PartsSearch.vue";
import QuotedParts from "../components/requiredParts/QuotedParts.vue";
import { loadParts } from "@/common/jobLoader";
import moment from "moment";
import store from "@/store/store";

@Component({
  components: {
    DetailHeader,
    PartsSearch,
    QuotedParts
  }
})
export default class ExamDetail extends Vue {
  protected loadingJob: boolean = true;

  // Lifecycles

  public created() {
    this.$watch(() => this.$route.params.id, this.loadJob);
    this.loadJob(this.$route.params.id);
  }

  public async loadJob(jobId: string) {
    this.loadingJob = true;

    try {
      await loadParts(jobId);
    } catch (err) {
      this.$router.push("/");
      this.$notify.error({
        title: "Error",
        message: err.message,
        offset: 48
      });
    } finally {
      this.loadingJob = false;
    }
  }

  public displayDate(date: moment.Moment) {
    return date.isValid() ? date.format("DD-MMM-YYYY") : "No Date";
  }

  public nearbyJobsClicked() {
    this.$router.push(
      `/ByPostcode/${store.state.Job.JobDetail!.AddressPostcode}`
    );
  }

  public doneClicked() {
    this.$router.push(`/Job/${store.state.Job.JobId}`);
  }

  // Getters
  get jobId() {
    return store.state.Job.JobId;
  }

  get jobDetail() {
    return store.state.Job.JobDetail;
  }

  get examDetail() {
    return store.state.Job.ExamDetail;
  }

  get partsDetail() {
    return store.state.Job.PartsDetail;
  }

  get detailDescription() {
    if (this.jobDetail) {
      return `(${store.state.Job.JobId}) Parts required for ${
        this.jobDetail!.DivisionName
      }`;
    }
  }

  get parts() {
    return this.partsDetail ? this.partsDetail.Parts : [];
  }
}
